/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../api/contract';
import './action';
import './channel';
import './customer_metadata';
import './request';
import './decision_method';
import './risk_signals';
import './sandbox_metadata';
import './grant';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "grantly": {
            "nested": {
              "api": {
                "nested": {
                  "CreateRequestRequest": {
                    "fields": {
                      "metadata": {
                        "type": "squareup.cash.api.RequestMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "idempotencyKey": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "request": {
                        "type": "squareup.cash.grantly.api.CreateRequestRequest.Request",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Request": {
                        "fields": {
                          "clientId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "referenceId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "actions": {
                            "type": "squareup.cash.grantly.api.Action",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "metadata": {
                            "type": "string",
                            "id": 4,
                            "keyType": "string"
                          },
                          "redirectUrl": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "channel": {
                            "type": "squareup.cash.grantly.api.Channel",
                            "id": 6,
                            "rule": "required"
                          },
                          "customerMetadata": {
                            "type": "squareup.cash.grantly.api.CustomerMetadata",
                            "id": 7,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "CreateRequestResponse": {
                    "fields": {
                      "metadata": {
                        "type": "squareup.cash.api.ResponseMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "request": {
                        "type": "squareup.cash.grantly.api.Request",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "UpdateRequestRequest": {
                    "fields": {
                      "metadata": {
                        "type": "squareup.cash.api.RequestMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "requestId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "request": {
                        "type": "squareup.cash.grantly.api.UpdateRequestRequest.Request",
                        "id": 3,
                        "rule": "optional"
                      },
                      "actorClientId": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "fieldsToClear": {
                        "type": "squareup.cash.grantly.api.Request.ClearableField",
                        "id": 5,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Request": {
                        "fields": {
                          "clientId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "referenceId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "actions": {
                            "type": "squareup.cash.grantly.api.Action",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "metadata": {
                            "type": "string",
                            "id": 4,
                            "keyType": "string"
                          }
                        }
                      }
                    }
                  },
                  "UpdateRequestResponse": {
                    "fields": {
                      "metadata": {
                        "type": "squareup.cash.api.ResponseMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "request": {
                        "type": "squareup.cash.grantly.api.Request",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "DecideRequestRequest": {
                    "fields": {
                      "metadata": {
                        "type": "squareup.cash.api.RequestMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "requestId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "decision": {
                        "type": "squareup.cash.grantly.api.DecideRequestRequest.Decision",
                        "id": 3,
                        "rule": "optional"
                      },
                      "customerId": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "decisionMethod": {
                        "type": "squareup.cash.grantly.api.DecisionMethod",
                        "id": 5,
                        "rule": "optional"
                      },
                      "riskSignals": {
                        "type": "squareup.cash.grantly.api.RiskSignals",
                        "id": 6,
                        "rule": "optional"
                      },
                      "sandboxMetadata": {
                        "type": "squareup.cash.grantly.api.SandboxMetadata",
                        "id": 7,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Decision": {
                        "values": {
                          "APPROVE": 1,
                          "DECLINE": 2,
                          "PROCESSING": 3
                        }
                      }
                    }
                  },
                  "DecideRequestResponse": {
                    "fields": {
                      "metadata": {
                        "type": "squareup.cash.api.ResponseMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "request": {
                        "type": "squareup.cash.grantly.api.Request",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "RetrieveRequestRequest": {
                    "fields": {
                      "metadata": {
                        "type": "squareup.cash.api.RequestMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "requestId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "validityToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "clientId": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "includeExpired": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "RetrieveRequestResponse": {
                    "fields": {
                      "metadata": {
                        "type": "squareup.cash.api.ResponseMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "request": {
                        "type": "squareup.cash.grantly.api.Request",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "AddAppDataRequest": {
                    "fields": {
                      "metadata": {
                        "type": "squareup.cash.api.RequestMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "requestId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "appData": {
                        "type": "squareup.cash.grantly.api.Grant.AppData",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "AddAppDataResponse": {
                    "fields": {
                      "metadata": {
                        "type": "squareup.cash.api.ResponseMetadata",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "RequestService": {
                    "methods": {
                      "CreateRequest": {
                        "requestType": "squareup.cash.grantly.api.CreateRequestRequest",
                        "responseType": "squareup.cash.grantly.api.CreateRequestResponse"
                      },
                      "RetrieveRequest": {
                        "requestType": "squareup.cash.grantly.api.RetrieveRequestRequest",
                        "responseType": "squareup.cash.grantly.api.RetrieveRequestResponse"
                      },
                      "DecideRequest": {
                        "requestType": "squareup.cash.grantly.api.DecideRequestRequest",
                        "responseType": "squareup.cash.grantly.api.DecideRequestResponse"
                      },
                      "AddAppData": {
                        "requestType": "squareup.cash.grantly.api.AddAppDataRequest",
                        "responseType": "squareup.cash.grantly.api.AddAppDataResponse"
                      },
                      "UpdateRequest": {
                        "requestType": "squareup.cash.grantly.api.UpdateRequestRequest",
                        "responseType": "squareup.cash.grantly.api.UpdateRequestResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.CreateRequestRequest && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.CreateRequestRequest?.nested?.Request && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.CreateRequestResponse && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.UpdateRequestRequest && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.UpdateRequestRequest?.nested?.Request && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.UpdateRequestResponse && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.DecideRequestRequest && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.DecideRequestRequest?.nested?.Decision && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.DecideRequestResponse && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.RetrieveRequestRequest && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.RetrieveRequestResponse && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.AddAppDataRequest && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.AddAppDataResponse && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.RequestService) {
  $root.addJSON(jsonData);
}

/**
 * Describes the request payload for a CreateRequest RPC call.
 *
 * SOURCE CreateRequestRequest @ squareup/cash/grantly/api/request_service.proto at 20:1
 */
export const CreateRequestRequest = $root.lookupType('squareup.cash.grantly.api.CreateRequestRequest');
fixType(CreateRequestRequest);
Builder.createAndAttachToType(CreateRequestRequest);
/**
 * Next ID: 4
 * Describes the set of parameters on a request you can set in the
 * CreateRequest RPC call.
 *
 * SOURCE Request @ squareup/cash/grantly/api/request_service.proto at 46:3
 */
CreateRequestRequest.Request = $root.lookupType('squareup.cash.grantly.api.CreateRequestRequest.Request');
fixType(CreateRequestRequest.Request);
Builder.createAndAttachToType(CreateRequestRequest.Request);
/**
 * Describes the response payload for a CreateRequest RPC call.
 *
 * SOURCE CreateRequestResponse @ squareup/cash/grantly/api/request_service.proto at 114:1
 */
export const CreateRequestResponse = $root.lookupType('squareup.cash.grantly.api.CreateRequestResponse');
fixType(CreateRequestResponse);
Builder.createAndAttachToType(CreateRequestResponse);
/**
 * Describes the request payload for a UpdateRequest RPC call.
 *
 * SOURCE UpdateRequestRequest @ squareup/cash/grantly/api/request_service.proto at 135:1
 */
export const UpdateRequestRequest = $root.lookupType('squareup.cash.grantly.api.UpdateRequestRequest');
fixType(UpdateRequestRequest);
Builder.createAndAttachToType(UpdateRequestRequest);
/**
 * Next ID: 6
 * Describes the set of parameters on a request you can set in the
 * UpdateRequest RPC call.
 *
 * SOURCE Request @ squareup/cash/grantly/api/request_service.proto at 177:3
 */
UpdateRequestRequest.Request = $root.lookupType('squareup.cash.grantly.api.UpdateRequestRequest.Request');
fixType(UpdateRequestRequest.Request);
Builder.createAndAttachToType(UpdateRequestRequest.Request);
/**
 * Describes the response payload for a UpdateRequest RPC call.
 *
 * SOURCE UpdateRequestResponse @ squareup/cash/grantly/api/request_service.proto at 224:1
 */
export const UpdateRequestResponse = $root.lookupType('squareup.cash.grantly.api.UpdateRequestResponse');
fixType(UpdateRequestResponse);
Builder.createAndAttachToType(UpdateRequestResponse);
/**
 * Describes the request payload for a DecideRequest RPC call.
 *
 * SOURCE DecideRequestRequest @ squareup/cash/grantly/api/request_service.proto at 245:1
 */
export const DecideRequestRequest = $root.lookupType('squareup.cash.grantly.api.DecideRequestRequest');
fixType(DecideRequestRequest);
Builder.createAndAttachToType(DecideRequestRequest);
/**
 * Next ID: 8
 * Represents the list of decisions a mobile app can take on the request.
 *
 * SOURCE Decision @ squareup/cash/grantly/api/request_service.proto at 293:3
 */
DecideRequestRequest.Decision = $root.lookupEnum('squareup.cash.grantly.api.DecideRequestRequest.Decision').values;
/**
 * Describes the response payload for a DecideRequest RPC call.
 *
 * SOURCE DecideRequestResponse @ squareup/cash/grantly/api/request_service.proto at 318:1
 */
export const DecideRequestResponse = $root.lookupType('squareup.cash.grantly.api.DecideRequestResponse');
fixType(DecideRequestResponse);
Builder.createAndAttachToType(DecideRequestResponse);
/**
 * Describes the request payload for a RetrieveRequest RPC call.
 *
 * SOURCE RetrieveRequestRequest @ squareup/cash/grantly/api/request_service.proto at 339:1
 */
export const RetrieveRequestRequest = $root.lookupType('squareup.cash.grantly.api.RetrieveRequestRequest');
fixType(RetrieveRequestRequest);
Builder.createAndAttachToType(RetrieveRequestRequest);
/**
 * Describes the response payload for a RetrieveRequest RPC call.
 *
 * SOURCE RetrieveRequestResponse @ squareup/cash/grantly/api/request_service.proto at 385:1
 */
export const RetrieveRequestResponse = $root.lookupType('squareup.cash.grantly.api.RetrieveRequestResponse');
fixType(RetrieveRequestResponse);
Builder.createAndAttachToType(RetrieveRequestResponse);
/**
 * Describes the request payload for a AddAppData RPC call.
 *
 * SOURCE AddAppDataRequest @ squareup/cash/grantly/api/request_service.proto at 406:1
 */
export const AddAppDataRequest = $root.lookupType('squareup.cash.grantly.api.AddAppDataRequest');
fixType(AddAppDataRequest);
Builder.createAndAttachToType(AddAppDataRequest);
/**
 * Describes the response payload for a AddAppData RPC call.
 *
 * SOURCE AddAppDataResponse @ squareup/cash/grantly/api/request_service.proto at 433:1
 */
export const AddAppDataResponse = $root.lookupType('squareup.cash.grantly.api.AddAppDataResponse');
fixType(AddAppDataResponse);
Builder.createAndAttachToType(AddAppDataResponse);
/**
 * The RequestService supports the creation and management of customer requests
 * which can be used by third-parties to request access to perform actions on
 * Cash App customer accounts.
 *
 * SOURCE RequestService @ squareup/cash/grantly/api/request_service.proto at 449:1
 */
export const RequestService = $root.lookupService('squareup.cash.grantly.api.RequestService');